import { AxiosError } from "axios";

import { getPartnerToken } from "./get-partner-token";
import { gupshupIntegrationService } from "@/api/customer-platform/whatsapp/gupshup-integration";
import { apiGupShup } from "@/lib/axios";

export interface IGupshupWabaInfo {
  accountStatus?: string;
  dockerStatus?: string;
  messagingLimit?: string;
  mmLiteStatus?: string;
  ownershipType?: string;
  phone?: string;
  phoneQuality?: string;
  throughput?: string;
  verifiedName?: string;
  wabaId?: string;
  canSendMessage?: string;
  errors?: Array<{
    error_code?: string;
    error_description?: string;
    possible_solution?: string;
  }>;
  additionalInfo?: string[];
}

export async function getGupshupWabaInfo(appId: string): Promise<IGupshupWabaInfo> {
  try {
    const partnerToken = await getPartnerToken();
    const appToken = await gupshupIntegrationService.getAppToken(appId, partnerToken);

    let response;
    try {
      response = await apiGupShup.get(`/app/${appId}/waba/info`, {
        headers: {
          token: appToken,
        },
      });
    } catch (tokenError) {
      if (tokenError instanceof AxiosError && (tokenError.response?.status === 401 || tokenError.response?.status === 403)) {
        response = await apiGupShup.get(`/app/${appId}/waba/info`, {
          headers: {
            Authorization: appToken,
          },
        });
      } else {
        throw tokenError;
      }
    }

    const wabaInfo = response.data?.wabaInfo;
    if (!wabaInfo) {
      throw new Error("WABA info not found in response");
    }

    return wabaInfo;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        throw new Error("UNAUTHORIZED");
      }
      if (error.response?.status === 400) {
        const errorMessage = error.response?.data?.message || error.message;
        throw new Error(`Failed to get WABA info: ${errorMessage}`);
      }
      throw new Error(
        `Failed to get WABA info: ${error.response?.data?.message || error.message}`
      );
    }
    throw new Error("Failed to get WABA info");
  }
}

